import React from 'react'
import { Flex, FlexProps } from '@mprolab/uikit'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  max-width: 1215px;
`

interface LayoutProps extends FlexProps {
  children: React.ReactNode
}

const MainWrapper: React.FC<LayoutProps> = ({ children, ...props }) => {
  return <Wrapper {...props}>{children}</Wrapper>
}

export default MainWrapper
